import React from 'react'
import styled from 'styled-components/macro'

import { Heading, AccentBar, MaxWidthWrapper } from '../styles'
import { Grid } from '@tiltify/ui'
import { SupportingCard } from './SupportingCard'
import brc from './brc.png'
import calm from './calm.png'
import dogs from './dogs.png'
import grand from './grand.png'
import hunt from './hunt.png'
import kidscape from './kidscape.png'
import mermaids from './mermaids.png'
import movember from './movember.png'
import olympics from './olympics.png'
import reset from './reset.png'
import special from './special.png'
import wdc from './wdc.png'

const StyledGrid = styled(Grid)`
  min-height: 200px;
  padding-bottom: 1rem;

  @media (max-width: calc(${({ theme }) => theme.contentMaxWidth} - 32px)) {
    grid-template-columns: repeat(2, minmax(${({ itemWidth }) => itemWidth}, 1fr));
  }

  @media (max-width: ${({ theme }) => theme.breakpoints[1]}) {
    grid-template-columns: repeat(auto-fit, minmax(${({ itemWidth }) => itemWidth}, 1fr));
  }
`

const Paragraph = styled.p`\
font-family: 'Montserrat';
font-style: normal;
font-weight: 400;
font-size: 20px;
line-height: 32px;
text-align: center;
letter-spacing: 1px;
color: #333333;
`

export const causeList = [
  {
    name: 'British Red Cross',
    description: 'Providing Ukraine aid & Young Refugee support in the UK',
    region: '576',
    logo: brc,
    url: 'https://tiltify.com/british-red-cross',
  },
  {
    name: 'Campaign Against Living Miserably (CALM)',
    description: 'Standing against suicide so no one feels alone',
    region: '575',
    logo: calm,
    url: 'https://tiltify.com/calm',
  },
  {
    name: 'Dogs For Autism',
    description: 'Fund pups like ‘JJ’ and change lives for autistic young adults',
    region: '564',
    logo: dogs,
    url: 'https://tiltify.com/dogs-for-autism',
  },
  {
    name: 'The Grand Appeal',
    description: 'Creating Jingle Jam Building to help sick kids in the South West.',
    region: '565',
    logo: grand,
    url: 'https://tiltify.com/the-grand-appeal',
  },
  {
    name: "Huntington's Disease Association ",
    description: "support for young people in families affected by Huntington's disease",
    region: '567',
    logo: hunt,
    url: 'https://tiltify.com/huntingtons-disease-association',
  },
  {
    name: 'Kidscape',
    description: 'Anti-bullying help for children from all walks of life',
    region: '568',
    logo: kidscape,
    url: 'https://tiltify.com/kidscape',
  },
  {
    name: 'Mermaids',
    description: 'giving trans youth more opportunities and safe spaces',
    region: '569',
    logo: mermaids,
    url: 'https://tiltify.com/mermaids',
  },
  {
    name: 'Movember',
    description: "Changing the face of men's health",
    region: '570',
    logo: movember,
    url: 'https://tiltify.com/movember',
  },
  {
    name: 'Reset Mental Health',
    description: 'Improve young adults mental health in underfunded black communities',
    region: '571',
    logo: reset,
    url: 'https://tiltify.com/reset-mh',
  },
  {
    name: 'SpecialEffect',
    description: 'Bring fun and inclusion to 100s of disabled and seriously ill kids',
    region: '572',
    logo: special,
    url: 'https://tiltify.com/specialeffect',
  },
  {
    name: 'Special Olympics Great Britain',
    description: 'Enabling athletes to attend the Special Olympics World Games 2023',
    region: '573',
    logo: olympics,
    url: 'https://tiltify.com/special-olympics-gb',
  },
  {
    name: 'Whale and Dolphin Conservation',
    description: 'Saving whales and dolphins in Scottish waters',
    region: '574',
    logo: wdc,
    url: 'https://tiltify.com/wdc',
  },
]

export const Causes = (): JSX.Element | null => {
  return (
    <MaxWidthWrapper>
      <Heading>Jingle Jam supported these amazing charities in 2022</Heading>
      <AccentBar />
      <Paragraph>
        You can still choose to fundraise or donate directly to them on the links below.
      </Paragraph>
      <div>
        <StyledGrid itemWidth='260px'>
          {causeList.map((cause) => (
            <SupportingCard cause={cause} key={cause.region} />
          ))}
        </StyledGrid>
      </div>
    </MaxWidthWrapper>
  )
}
